/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'

interface iPieChartData{
  nome: string
  series: string[]
  labels: string[]
}

interface PiechartProps {
  id: string
  data: iPieChartData
  colorsGrafico: string[]
}

export const PieChart: React.FC<PiechartProps> = ({ id, data, colorsGrafico }) => {
  function GerarGrafico(): void {
    const options = {
      series: data.series,
      chart: {
        type: 'pie'
      },
      colors: colorsGrafico,
      dataLabels: {
        enabled: true
      },
      legend: {
        show: false,
        onItemHover: {
          highlightDataSeries: false
        }
      },
      labels: data.labels,
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -10
          }
        }
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
        <Flex id={`chart-${id}`} w={'400px'}/>
  )
}
